import { Component } from '@angular/core';

@Component({
  selector: 'tln-kiwihr-logo',
  templateUrl: './kiwihr-logo.component.html',
  styleUrls: ['./kiwihr-logo.component.less'],
  standalone: true,
})
export class KiwihrLogoComponent {}
